/**
 * Curated suggestions for the OpenRouter model picker.
 *
 * Free-text input always wins — this list is just a `<datalist>` of "common
 * picks" so the user doesn't have to remember exact slugs. All entries below
 * support OpenAI-style tool calling (required by the NL Keepa Search feature).
 *
 * OpenRouter's catalog churns; refresh this list when a model retires or a
 * cheaper tool-capable option appears.
 */
export const OPENROUTER_MODEL_SUGGESTIONS = [
  'anthropic/claude-haiku-4.5',
  'anthropic/claude-sonnet-4.6',
  'google/gemini-2.5-flash',
  'openai/gpt-5-mini',
  'meta-llama/llama-4-maverick',
] as const;

export type OpenRouterModelSuggestion = (typeof OPENROUTER_MODEL_SUGGESTIONS)[number];

/** OpenRouter slug shape: `org/model[-variant]`. Validated client + server. */
export const OPENROUTER_MODEL_REGEX = /^[a-z0-9-]+\/[a-z0-9.\-_]+$/i;
